import { cn } from "@garther/ui/libs";

interface LogoProps {
  className?: string;
}

export function Logo({ className }: LogoProps) {
  return (
    <a
      href="/"
      className={cn("h-9 w-9 flex items-center justify-center overflow-hidden", className)}
      aria-label="ASA Hub Homepage"
    >
      <img src="/logo.png" alt="ASA Hub Logo" className="w-full h-full object-contain" />
    </a>
  );
}
